var array = Array.prototype;

export var slice = array.slice;
export var map = array.map;



// WEBPACK FOOTER //
// C:/Dropbox/www/amcharts4dev/node_modules/d3-array/src/array.js